import { Lot, State } from '../types';
import { VIEW_MODES } from '../state';

export interface RemovalSelection {
  targetLots: Lot[];
  localIds: Set<string>;
  remoteIds: string[];
}

export function canArchiveUrls(state: State): boolean {
  return state.viewMode === VIEW_MODES.SUPERADMIN;
}

export function buildRemovalSelection(state: State, targetLots: Lot[]): RemovalSelection {
  const selection: RemovalSelection = {
    targetLots: [],
    localIds: new Set<string>(),
    remoteIds: [],
  };

  targetLots.forEach(lot => {
    if (!lot || !lot.id) {
      return;
    }

    selection.targetLots.push(lot);

    if (state.mode === 'auth0' || lot.remote) {
      selection.remoteIds.push(lot.id);
    } else {
      selection.localIds.add(lot.id);
    }
  });

  return selection;
}
